
import { defineComponent, ref, watch } from 'vue';
import { Dropdown, Menu } from 'ant-design-vue';
import { DownOutlined, UserOutlined, ExportOutlined } from '@ant-design/icons-vue';
import { useRoute, useRouter } from 'vue-router';
import Common from '@/store/common';
import api from '@/axios/api';
import useUserHooks from '@/hooks/user.hooks';
import useConfigHooks from '@/hooks/config.hooks';

interface Nav {
  name: string;
  isActived: boolean;
  pathName?: string;
}

export default defineComponent({
  components: {
    aDropdown: Dropdown,
    aMenu: Menu,
    aMenuItem: Menu.Item,
    DownOutlined,
    UserOutlined,
    ExportOutlined,
  },
  props: {},
  setup() {
    const router = useRouter();
    const route = useRoute();
    const userHooks = useUserHooks();
    const configHooks = useConfigHooks();
    const headers = ref<Nav[]>([
      // { name: '首页', isActived: true, pathName: '/Student/home' },
      // { name: '案例分析', isActived: false, pathName: '/Student/analysis' },
      // { name: '应急资源库', isActived: false },
      // { name: '实验报告', isActived: false, pathName: '/Student/report' },
      // { name: '成绩排名', isActived: false, pathName: '/Student/scoreRanking' },
      // { name: '帮助', isActived: false },
      { name: '首页', isActived: true, pathName: '/Student/home' },
      { name: '应急资源库', isActived: false },
      { name: '成绩中心', isActived: false, pathName: '/Student/scoreRanking' },
      { name: '帮助', isActived: false },
      { name: '资源下载', isActived: false, pathName: '/Student/resourceDownload' },
    ]);

    const userName = Common.getState().name;
    const { headImagePath } = Common.getState();

    const handleLogoutClick = () => {
      api.logOut();
      userHooks.logout();
      router.push('/');
    };
    const initIndex = (i: number) => {
      headers.value = headers.value.map((n) => ({ ...n, isActived: false }));
      headers.value[i].isActived = true;
    };
    const routeTo = (nav: Nav, navI: number) => {
      if (nav.pathName) {
        router.push(nav.pathName);
        initIndex(navI);
      }
    };
    const handleUserInfo = () => {
      router.push('/Student/userInfo');
    };

    watch(() => route.name, () => {
      const findI = headers.value.findIndex((h) => h.pathName && h.pathName === route.path);
      if (findI !== -1) initIndex(findI);
    }, { immediate: true, deep: true });

    return {
      headers,
      userName,
      headImagePath,
      handleLogoutClick,
      routeTo,
      handleUserInfo,
      projectName: configHooks.softConfig.get().softName,
    };
  },
});
